import { useAxios } from '@/hooks';
import { setUserData } from '@/redux/actions/user.action';
import { RootState, AppDispatch } from '@/redux/store';
import { getCookie, deleteCookie, endPoint } from '@/utils';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

export const useLogin = () => {
  const userData = useSelector((state: RootState) => state.user.user);

  const dispatch = useDispatch<AppDispatch>();
  const { fetchData, loading, error } = useAxios();
  const initialized = React.useRef(false);

  React.useEffect(() => {
    const handleUser = async () => {
      const token = getCookie('token');
      if (!token || initialized.current) return;

      initialized.current = true;

      if (!userData?.accessToken) {
        const res = await fetchData({
          url: endPoint.USER_PROFILE,
          method: 'GET',
        });

        if (res.status === 200 && res.data) {
          dispatch(setUserData({ ...res.data, accessToken: token }));
        } else {
          deleteCookie('token');
          initialized.current = false;
        }
      } else {
        dispatch(setUserData({ ...userData, accessToken: token }));
      }
    };

    handleUser();
  }, [dispatch, fetchData, userData]);

  return { userData, loading, error };
};
